import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {CallanOnlineRecognizeService} from 'src/app/services/callan-online-recognize.service';
import {AuthServiceProvider} from 'src/app/services/col2/auth.service';
import {FunctionalAccessService} from 'src/app/services/functional-access.service';
import {ThemeService} from 'src/app/services/theme.service';
import {environment} from "../../../environments/environment";
import * as Sentry from "@sentry/angular";
import {SchoolV3RestService} from "../../services/rest/v3/school-rest.service";

@Component({
    selector: 'manager-main-nav',
    templateUrl: './manager-main-nav.component.html',
    styleUrls: ['./manager-main-nav.component.scss'],
    standalone: false
})
export class ManagerMainNavComponent implements OnInit, AfterViewInit {
  private activeSegments: string[];
  private activePath: string;
  hasManyManagedSchools: boolean
  isGroupVisible = environment.isGroupVisible
  isManagerSubscriptionsVisible = environment.isManagerSubscriptionsVisible

  @Input() isOffcanvas: boolean = false;
  @Input() schoolId: String;

  disableVideo = true;
  theme: string;

  constructor(
    private authService: AuthServiceProvider,
    private callanOnlineRecognize: CallanOnlineRecognizeService,
    functionalityAccessService: FunctionalAccessService,
    public themeService: ThemeService,
    router: Router,
    private schoolV3Rest: SchoolV3RestService,
  ) {
    functionalityAccessService.getAccessState().subscribe((accessList) => {
      this.disableVideo = accessList.videoDisabled;
    });
    themeService.getTheme().subscribe((theme) => (this.theme = theme));
    router.events
      .pipe(filter((e: Event): e is NavigationStart | NavigationEnd | NavigationCancel | NavigationError => e instanceof NavigationStart ||
        e instanceof NavigationEnd ||
        e instanceof NavigationCancel ||
                                  e instanceof NavigationError))
      .subscribe((e: RouterEvent) => {
        this.activePath = e['urlAfterRedirects'];
        this.activePath
          ? (this.activeSegments = this.activePath.split('/'))
          : '';
      });
  }

  ngOnInit(): void {
    this.schoolV3Rest.listSchools().subscribe(schools => this.hasManyManagedSchools = !schools.empty)
  }

  ngAfterViewInit(): void {
    const feedback = Sentry.feedbackIntegration();
    const buttons = document.querySelectorAll("#reportABugButton")

    if (buttons.length && !Array.from(buttons).every(button => button.hasAttribute("data-feedback-attached"))) {
      buttons.forEach(button => {
        feedback.attachTo(button)
        button.setAttribute("data-feedback-attached", "true")
      })
    }
  }

  isCallanOnline() {
    if (!this.schoolId) return false;
    return this.callanOnlineRecognize.isCallanOnlineFranchiseById(
      Number(this.schoolId)
    );
  }

  logout() {
    this.authService.get().subscribe((api) => api.logout());
  }

  getDismiss() {
    return this.isOffcanvas && 'offcanvas';
  }

  isActive(segments: string) {
    return this.activeSegments[1] === 'school' &&
      segments
        .split(';')
        .some((segment) => this.activeSegments[3].includes(segment));
  }

  logOutFromManager() {
    this.authService.get().subscribe((auth) => auth.logOutFromManager());
  }

  isAdminLoggedInAsManager() {
    return this.authService
      .get()
      .pipe(map((auth) => auth.isLoggedInAsManager()));
  }
}
